// extracted by mini-css-extract-plugin
module.exports = {"item":"_28508-OfbaPI","select":"NTjqeDwJ2jZG"};